import React, { useEffect, useState ,useRef} from 'react'
import './Weather.css'
import search_icon from '../assets/search.png'
import clear_icon from "../assets/clear.png"
import cloud_icon from '../assets/cloud.png'
import drizzle_icon from '../assets/drizzle.png'
import rain_icon from '../assets/rain.png'
import snow_icon from '../assets/snow.png'
import wind_icon from '../assets/wind.png'
import humidity_icon from '../assets/humidity.png'

const Weather = () => {

    const inputRef =useRef()    
    const [weatherData,setWeatherData]=useState(false)
    const allIcons={
        "0id":clear_icon,
        "01n":clear_icon,
        "02d":cloud_icon,
        "03d":cloud_icon,
        "03n":cloud_icon,
        "04d":drizzle_icon,
        "04n":drizzle_icon,
        "09d":rain_icon,
        "09n":rain_icon,
        "10d":rain_icon,
        "10n":rain_icon,
        "13d":snow_icon,
        "13n":snow_icon,
    }
    

    const search=async (city)=>{
        if(city===""){alert("Enter city name")
             return;}
        try{
            const url=`https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=d3d9ad3310d06220a24535164c959a82`
            const response =await fetch(url)
            const data=await response.json()

            if(!response.ok){
                alert(data.message)
                return
            }
            console.log(data)
            const icon =allIcons[data.weather[0].icon] || clear_icon
            /* https://openweathermap.org/img/wn/10d@2x.png */
            setWeatherData({
                humidity: data.main.humidity,
                windSpeed: data.wind.speed,
                temperature: Math.floor(data.main.temp),
                location:data.name,
                icon:icon,
                i:"https://openweathermap.org/img/wn/10d@2x.png"
            })
        }catch (error){
            setWeatherData(false)
            console.log(error)
        }
    }
    useEffect(()=>{
        search("Dharmavaram")
    },[])
  return (
    <div className='weather'>
        <div className="search-bar">
            <input type="text" ref={inputRef} className="text" placeholder='Search' />
            <img src={search_icon} onClick={()=>search(inputRef.current.value)} alt="" />
        </div>
        {weatherData?<>
            <img src={weatherData.icon} className='weather-icon'/>
        
        <p className='temperature'>{weatherData.temperature}°C</p>
        <p className='location'>{weatherData.location}</p>
        <div className="weather-data">
            <div className="col">
                <img src={humidity_icon} alt="" />
                <div>
                    <p>{weatherData.humidity}%</p>
                    <span>Humidity</span>
                </div>
            </div>
            <div className="col">
                <img src={wind_icon}/>
                <div>
                    <p>{weatherData.windSpeed}Kmph</p>
                    <span>Wind Speed</span>
                </div>
            </div>
        </div>
        
        </>:<></>}
        

    </div>
  )
}

export default Weather